import {Container, Grid, Typography, useMediaQuery, useTheme} from '@material-ui/core';
import {WithStyles, withStyles} from '@material-ui/core/styles';
import {WithTranslation, withTranslation} from 'react-i18next';

import {technologyStackStyles} from 'src/Components/Home/TechnologyStack/technologyStackStyles';
import ElasticSearch from 'src/Components/Technologies/ElasticSearch';
import ElectronJS from 'src/Components/Technologies/ElectronJS';
import GraphQL from 'src/Components/Technologies/GraphQL';
import JavaScript from 'src/Components/Technologies/Javascript';
import Laravel from 'src/Components/Technologies/Laravel';
import MySQL from 'src/Components/Technologies/MySQL';
import Php from 'src/Components/Technologies/Php';
import RabbitMQ from 'src/Components/Technologies/RabbitMQ';
import ReactJS from 'src/Components/Technologies/ReactJS';
import ReactNative from 'src/Components/Technologies/ReactNative';
import Redis from 'src/Components/Technologies/Redis';
import {IAnchorable} from 'src/Routes/Pages/IAnchorable';
import NextJs from 'src/Components/Technologies/NextJs';
import NestJs from 'src/Components/Technologies/NestJs';
import WebRTC from 'src/Components/Technologies/WebRTC';
import Redux from 'src/Components/Technologies/Redux';
import Docker from 'src/Components/Technologies/Docker';
import Lemp from 'src/Components/Technologies/Lemp';

const TechnologyStack = (props: IAnchorable & WithStyles & WithTranslation) => {
	const theme = useTheme();
	const matchesMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<Container maxWidth="lg" component="section" id={props.anchor}>
			<Grid container className={props.classes.root}>
				<Grid item xs={12}>
					<Typography variant="h3" className={props.classes.title}>
						{props.t('our-stack')}
					</Typography>
					<Typography variant="body2" className={props.classes.subTitle}>
						{props.t('sub-title')}
					</Typography>
				</Grid>
				<Grid item container xs={12} className={props.classes.techGrid} spacing={matchesMobile ? 0 : 5}>
					<Grid item xs={4} sm className={props.classes.tech}>
						<JavaScript />
					</Grid>
					<Grid item xs={4} sm className={props.classes.tech}>
						<ReactJS />
					</Grid>
					<Grid item xs={4} sm className={props.classes.tech}>
						<ReactNative />
					</Grid>
					<Grid item xs={4} sm className={props.classes.tech}>
						<ElectronJS />
					</Grid>
					<Grid item xs={4} sm className={props.classes.tech}>
						<GraphQL />
					</Grid>
					<Grid item xs={4} sm className={props.classes.tech}>
						<NextJs />
					</Grid>
				</Grid>
				<Grid item container xs={12} className={props.classes.techGrid} spacing={matchesMobile ? 0 : 5}>
					<Grid item xs={4} sm className={props.classes.tech}>
						<Laravel />
					</Grid>
					<Grid item xs={4} sm className={props.classes.tech}>
						<WebRTC />
					</Grid>
					<Grid item xs={4} sm className={props.classes.tech}>
						<NestJs />
					</Grid>
					<Grid item xs={4} sm className={props.classes.tech}>
						<Docker />
					</Grid>
					<Grid item xs={4} sm className={props.classes.tech}>
						<Lemp />
					</Grid>
					<Grid item xs={4} sm className={props.classes.tech}>
						<Redux />
					</Grid>
				</Grid>
				<Grid item container xs={12} className={props.classes.techGrid} spacing={matchesMobile ? 0 : 5}>
					<Grid item xs={4} sm className={props.classes.tech}>
						<Php />
					</Grid>
					<Grid item xs={4} sm className={props.classes.tech}>
						<MySQL />
					</Grid>
					<Grid item xs={4} sm className={props.classes.tech}>
						<ElasticSearch />
					</Grid>
					<Grid item xs={4} sm className={props.classes.tech}>
						<Redis />
					</Grid>
					<Grid item xs={4} sm className={props.classes.tech}>
						<RabbitMQ />
					</Grid>
				</Grid>
			</Grid>
		</Container>
	);
};

export default withStyles(technologyStackStyles)(withTranslation('technology')(TechnologyStack));
